var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.702 0H1.298C.581 0 0 .581 0 1.298v15.404C0 17.419.581 18 1.298 18h15.404c.717 0 1.298-.581 1.298-1.298V1.298C18 .581 17.419 0 16.702 0M6.385 13.606H4.193V7.01h2.192zM5.289 6.11h-.014c-.736 0-1.212-.507-1.212-1.14 0-.647.49-1.139 1.24-1.139s1.212.492 1.226 1.14c0 .632-.476 1.139-1.24 1.139m9 7.494h-2.192v-3.527c0-.887-.318-1.492-1.11-1.492-.606 0-.967.408-1.125.802-.058.14-.072.338-.072.535v3.682H7.598s.028-5.975 0-6.594H9.79v.934c.29-.45.812-1.089 1.975-1.089 1.442 0 2.523.943 2.523 2.968z"
  })));
};
export { SvgLinkedin as ReactComponent };
export default "/_next/static/chunks/svg/linkedin-1a0e0014e11fb3639f99a7c466556a0b.svg";